import type { Message, ReadState } from '../api/types'

/**
 * Whether a message can be unread by `reader`, the person's display name:
 * `domain.counts_as_unread`, for the messages the page learns of live. The
 * person's own messages and a run's own lines are never drawn as a row, so
 * nobody could see them; `tests/fixtures/counts_as_unread.json` pins the rule
 * here, in the domain and in the server's SQL.
 */
export function countsAsUnread(message: Message, reader: string): boolean {
  if (message.sender_type === 'event') return !message.reply_to
  return !(message.sender_type === 'human' && message.sender === reader)
}

/**
 * The messages of `messages` the person has not read: above the floor, with
 * no seen row, and able to be unread at all. Ids sort by time as strings, as
 * the server compares them.
 */
export function unreadIn(messages: Message[], state: ReadState, reader: string): Set<string> {
  const seen = new Set(state.seen)
  return new Set(messages
    .filter((message) => message.id > state.read_through && !seen.has(message.id) && countsAsUnread(message, reader))
    .map((message) => message.id))
}
